import React, {Component} from 'react';
import {Button, Col, Input, Label, Row, UncontrolledTooltip} from "reactstrap";
import {request} from "../helper/APIUtils";
import {showAxiosError} from "../helper/helper";
import {validateField} from "../common/validation";
import Swal from "sweetalert2";
import {SERVLET_PATH, VirtualHost} from "../constants";
import {showBaro, showBaroLoginPage} from "../helper/permission";

class ForgotPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            informations: {
                vkntckn: "",
                username: "",
                email: ""
            },
            error: {},
        }
        this.handleChange = this.handleChange.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.onHandleBlur = this.onHandleBlur.bind(this);
    }

    goLogin() {
        let self = this;
        self.props.close(false);
    }

    handleChange(e) {
        let self = this;
        let name = e.target.name;
        let value = e.target.value;
        let informations = self.state.informations;
        informations[name] = value;
        self.setState({informations});
        self.validateField(e);
    }

    handleConfirm() {
        let self = this;

        if (self.state.informations && self.state.informations.username.endsWith("_eczpos")) {
            Swal({
                title: 'Uyarı',
                html: "Eczacıpos kullanıcı şifre değişim işlemleri için lüften eczacıpos çağrı merkeziyle(0850 259 9808) iletişime geçiniz.",
                showConfirmButton: true,
                confirmButtonText: "Tamam",
            }).then((result) => {
                if (result.value) {
                    Swal.close();
                }
            });
        } else {
            self.setState({processing: true});

            const params = {
                url: `/user/forgotPassword`,
                method: "post",
                data: self.state.informations
            }

            request(params).then((response) => {
                self.setState({processing: false});
                Swal({
                    confirmButtonText: 'Tamam',
                    type: 'success',
                    html: response.data + (
                        "<br/>e-Fatura, e-Arşiv fatura gönderiminde connector yada başka bir uygulama kullanan müşterilerimiz " +
                        "bu şifreyi kullanmış olduğunuz uygulamada da güncellemeniz gerekmektedir." +
                        " Aksi halde fatura alımı/gönderimi yapılamaz."
                    ),
                    width: '600px',
                }).then(function () {
                    self.goLogin()
                });
            }).catch(error => {
                self.setState({processing: false});
                showAxiosError(error);
            });
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    onHandleBlur(e) {
        let self = this;
        self.validateField(e);
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    isEnableButton() {
        let self = this;
        let error = self.state.error;
        const fields = Object.keys(error);
        let disabled = false;
        if (fields.length === 3)
            fields.forEach(field => {
                if (!error[field].valid) disabled = true
            })
        else
            disabled = true;
        return disabled;
    }

    render() {
        return (
            <Col id="forgot-container-col" style={{display: 'flex', flexDirection: 'column'}}>

                {showBaroLoginPage() &&
                    <Row id="forgot-logo-container" className="justify-content-md-center">
                        <img src={SERVLET_PATH + "/api/virtual/resource/loginBaro.png"} alt="now-logo"/>
                    </Row>}

                <div id="forgot-password">
                    {showBaroLoginPage() &&
                        <Row style={{padding: '2% 20% 5% 20%'}}>
                            <Col xs='12' className="input-group"
                                 style={{
                                     borderBottom: '1px solid #8c8c8c',
                                     padding: '0 0 0 0',
                                     margin: '-10px 5px 20px 5px',
                                     height: '60px',
                                     display: 'flex',
                                     flexDirection: 'row',
                                     alignItems: 'flex-end'
                                 }}>

                                <p style={{
                                    fontSize: '17px',
                                    color: '#8c8c8c',
                                    padding: '5px 10px 10px 0px',
                                    margin: 0,
                                    width: '35%',
                                    fontFamily: 'sans-serif'
                                }}>Vkn/Tckn*</p>

                                <div className={"form-group" + this.validateClass('tVknTckn')} style={{width: '65%'}}>
                                    <input
                                        id="tVknTckn"
                                        name="vkntckn"
                                        data-vlength="10,11"
                                        data-vdata="identifier"
                                        onBlur={(e) => this.onHandleBlur(e)}
                                        value={this.state.informations.vkntckn}
                                        onChange={(e) => this.handleChange(e)}
                                        style={{fontSize: '18px', margin: '0 0 11px 0', width: '100%'}}
                                        type="text"/>
                                    {this.validateMessage('tVknTckn') !== "" &&
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="tVknTckn"
                                            delay={0}>
                                            {this.validateMessage("tVknTckn")}
                                        </UncontrolledTooltip>}
                                </div>
                            </Col>
                            <Col xs='12' className="input-group"
                                 style={{
                                     borderBottom: '1px solid #8c8c8c',
                                     padding: '0 0 0 0',
                                     margin: '-10px 5px 20px 5px',
                                     height: '60px',
                                     display: 'flex',
                                     flexDirection: 'row',
                                     alignItems: 'flex-end'
                                 }}>

                                <p style={{
                                    fontSize: '17px',
                                    color: '#8c8c8c',
                                    padding: '5px 10px 10px 0px',
                                    margin: 0,
                                    width: '35%',
                                    fontFamily: 'sans-serif'
                                }}>Kullanıcı Adı *</p>

                                <div className={"form-group" + this.validateClass('tUsername')} style={{width: '65%'}}>
                                    <input
                                        id="tUsername"
                                        name="username"
                                        data-vlength="1,250"
                                        onBlur={(e) => this.onHandleBlur(e)}
                                        onChange={(e) => this.handleChange(e)}
                                        value={this.state.informations.username}
                                        style={{fontSize: '18px', margin: '0 0 11px 0', width: '100%'}}
                                        type="text"/>
                                    {this.validateMessage('tUsername') !== "" &&
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tUsername"
                                            delay={0}>
                                            {this.validateMessage("tUsername")}
                                        </UncontrolledTooltip>}
                                </div>
                            </Col>
                            <Col xs='12' className="input-group"
                                 style={{
                                     borderBottom: '1px solid #8c8c8c',
                                     padding: '0 0 0 0',
                                     margin: '-10px 5px 20px 5px',
                                     height: '60px',
                                     display: 'flex',
                                     flexDirection: 'row',
                                     alignItems: 'flex-end'
                                 }}>

                                <p style={{
                                    fontSize: '17px',
                                    color: '#8c8c8c',
                                    padding: '5px 10px 10px 0px',
                                    margin: 0,
                                    width: '35%',
                                    fontFamily: 'sans-serif'
                                }}>E-posta *</p>

                                <div className={"form-group" + this.validateClass('tEmail')} style={{width: '65%'}}>
                                    <input
                                        name="email"
                                        id="tEmail"
                                        data-vlength="1,350"
                                        data-vdata="email"
                                        onBlur={(e) => this.onHandleBlur(e)}
                                        onChange={(e) => this.handleChange(e)}
                                        value={this.state.informations.email}
                                        style={{fontSize: '18px', margin: '0 0 11px 0', width: '100%'}}
                                        type="email"/>
                                    {this.validateMessage('tEmail') !== "" &&
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tEmail"
                                            delay={0}>
                                            {this.validateMessage("tEmail")}
                                        </UncontrolledTooltip>}
                                </div>
                            </Col>

                            {this.state.errorMessage &&
                                <Col xs='12' style={{textAlign: 'center', padding: '0', margin: '4% 0 0 0'}}>
                                    <label className='errorMessage'>{this.state.errorMessage}</label>
                                </Col>}

                        </Row>}

                    {showBaroLoginPage() &&
                        <Row>
                            <Col xs='6' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Button style={{width: '200px', borderRadius: 0, background: '#73b343'}}
                                        onClick={() => this.goLogin()}>
                                    {!this.state.processing ? 'Giriş Sayfası' : <i className="fa fa-spinner fa-spin"/>}
                                </Button>
                            </Col>
                            <Col xs='6' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Button disabled={this.isEnableButton()}
                                        style={{width: '200px', borderRadius: 0, background: '#5292c5'}}
                                        onClick={() => this.handleConfirm()}>
                                    {!this.state.processing ? 'Sıfırla' : <i className="fa fa-spinner fa-spin"/>}
                                </Button>
                            </Col>
                        </Row>}

                    {!showBaroLoginPage() &&
                        <Row className=" m-1 text-center">
                            <Col xs='12' className="input-group"><Label className="label">Vkn/Tckn *</Label>
                                <div className={"form-group" + this.validateClass('tVknTckn')}>
                                    <input
                                        id="tVknTckn"
                                        name="vkntckn"
                                        data-vlength="10,11"
                                        data-vdata="identifier"
                                        onBlur={(e) => this.onHandleBlur(e)}
                                        value={this.state.informations.vkntckn}
                                        onChange={(e) => this.handleChange(e)}
                                        style={{
                                            width: '150%',
                                            margin: '0 0 0 0',
                                            background: '#b5bdc6',
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: 'bold'
                                        }} className="form-control" type="text"/>
                                    {this.validateMessage('tVknTckn') !== "" &&
                                        <UncontrolledTooltip
                                            placement="top"
                                            target="tVknTckn"
                                            delay={0}>
                                            {this.validateMessage("tVknTckn")}
                                        </UncontrolledTooltip>}
                                </div>
                            </Col>
                        </Row>}

                    {!showBaroLoginPage() && <Row className=" m-1 text-center">
                        <Col xs='12' className="input-group">
                            <Label className="label">Kullanıcı Adı *</Label>
                            <div className={"form-group" + this.validateClass('tUsername')}>
                                <input
                                    id="tUsername"
                                    name="username"
                                    data-vlength="1,250"
                                    onBlur={(e) => this.onHandleBlur(e)}
                                    onChange={(e) => this.handleChange(e)}
                                    value={this.state.informations.username}
                                    style={{
                                        width: '150%',
                                        margin: '0 0 0 0',
                                        background: '#b5bdc6',
                                        color: 'white',
                                        fontSize: '14px',
                                        fontWeight: 'bold'
                                    }} className="form-control" type="text"/>
                                {this.validateMessage('tUsername') !== "" &&
                                    <UncontrolledTooltip
                                        placement="right"
                                        target="tUsername"
                                        delay={0}>
                                        {this.validateMessage("tUsername")}
                                    </UncontrolledTooltip>}
                            </div>
                        </Col>
                    </Row>}

                    {!showBaroLoginPage() &&
                        <Row className="m-1 text-center">
                            <Col xs='12' className="input-group">
                                <Label className="label">E-posta *</Label>
                                <div className={"form-group" + this.validateClass('tEmail')}>
                                    <input
                                        name="email"
                                        id="tEmail"
                                        data-vlength="1,350"
                                        data-vdata="email"
                                        onBlur={(e) => this.onHandleBlur(e)}
                                        onChange={(e) => this.handleChange(e)}
                                        value={this.state.informations.email}
                                        style={{
                                            width: '150%',
                                            margin: '0 0 0 0',
                                            background: '#b5bdc6',
                                            color: 'white',
                                            fontSize: '14px',
                                            fontWeight: 'bold'
                                        }} className="form-control" type="email"/>
                                    {this.validateMessage('tEmail') !== "" &&
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="tEmail"
                                            delay={0}>
                                            {this.validateMessage("tEmail")}
                                        </UncontrolledTooltip>}
                                </div>
                            </Col>
                        </Row>}

                    {!showBaroLoginPage() && <Row className="m-3">
                        <Col sm={4}>
                        </Col>
                        <Col sm={8} className="">
                            <Row className="text-center">
                                <Button className="ml-3" style={{background: "#73b343"}} onClick={() => this.goLogin()}>
                                    {!this.state.processing ? 'Giriş Sayfası' : <i className="fa fa-spinner fa-spin"/>}
                                </Button>
                                <Button disabled={this.isEnableButton()} className="ml-2"
                                        style={{background: "#5292c5"}}
                                        onClick={() => this.handleConfirm()}>
                                    {!this.state.processing ? 'Sıfırla' : <i className="fa fa-spinner fa-spin"/>}
                                </Button>
                            </Row>
                        </Col>
                    </Row>}
                </div>
            </Col>
        );
    }
}

export default ForgotPassword;